package info.rezident.app.ui.components.animations

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.animation.Keyframes
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div
import kotlin.random.Random

// Keep keyframes file-private to avoid name clashes
val fall = Keyframes {
    0.percent {
        Modifier
            .translateY(0.px)
            .rotate(0.deg)
            .opacity(1)
    }

    80.percent {
        Modifier.opacity(1)
    }

    100.percent {
        Modifier
            .translateY(600.px)
            .rotate(360.deg)
            .opacity(0)
    }
}

@Composable
fun ConfettiAnimation() {
    // Simple confetti animation using random colored shapes
    val confettiColors = listOf(
        Color.rgb(255, 183, 3), // Selective Yellow
        Color.rgb(251, 133, 0), // UT Orange
        Color.rgb(142, 202, 230), // Sky Blue
        Color.rgb(33, 158, 188), // Blue Green
        Color.rgb(255, 99, 132), // Pink/Red
        Color.rgb(255, 255, 255), // White
        Color.rgb(255, 214, 10), // Gold
        Color.rgb(44, 62, 80) // Dark Blue
    )
    val confettiCount = 100
    val confettiShapes = remember { List(confettiCount) { Random.nextInt(0, 3) } }
    val confettiPositions = remember { List(confettiCount) { Pair(Random.nextInt(10, 90), Random.nextInt(10, 90)) } }
    val confettiRotations = remember { List(confettiCount) { Random.nextInt(0, 360) } }
    val confettiSizes = remember { List(confettiCount) { Random.nextInt(10, 24) } }
    val confettiDuration = remember { List(confettiCount) { Random.nextInt(1, 3) } }
    val confettiDelays = remember { List(confettiCount) { Random.nextInt(0, 2000) } }

    Box(
        Modifier
            .fillMaxSize()
            .position(Position.Absolute)
            .top(0.px)
            .left(0.px)
            .pointerEvents(PointerEvents.None)
            .zIndex(1)
    ) {
        confettiPositions.forEachIndexed { i, (x, y) ->
            val color = confettiColors[i % confettiColors.size]
            val shape = confettiShapes[i]
            val size = confettiSizes[i]
            val rotation = confettiRotations[i]
            val speed = confettiDuration[i]
            val delay = confettiDelays[i]
            Div(
                {
                    style {
                        property("position", "absolute")
                        property("left", "$x%")
                        property("top", "-${size * 2}px")
                        property("width", "${size}px")
                        property("height", "${size}px")
                        property("background", color.toString())
                        property("border-radius", if (shape == 0) "50%" else if (shape == 1) "20%" else "0%")
                        property("transform", "rotate(${rotation}deg)")
                        property("animation", "fall ${speed}s linear ${delay}ms 1")
                    }
                }
            )
        }
    }
}